import {
  Button,
  FormGroup,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { Container, ContainerForm, ContainerFormRight, Title } from "../../styles/index.sty";
import AlertSnack from "../../components/Alert/AlertSnack";
import { useAuth } from "../../context/authContext";
import { useLists } from "../../context/listContext";
import { insertStoreData, updateStoreData } from "../../api/store.api";

export const AddStore = () => {
  const { config2, config } = useAuth();
  const { cityList, fetchCityList } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const storeData = location?.state?.data;
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState({});
  const [ timings, setTimings ] = useState({
    from: "00:00:00",
    to: "00:00:00"
  })
  useEffect(() => {
    fetchCityList();
  }, []);
  const formik = useFormik({
    initialValues: {
      store_name: storeData?.store_name,
      store_description: storeData?.store_description,
      store_address: storeData?.store_address,
      store_number: storeData?.store_number,
      // store_timings: storeData?.store_timings,
      city_id: storeData?.city_id,
    },
    onSubmit: async (values) => {
      setLoading(true);
      if (storeData) {
        const submit = await updateStoreData(
          {
            ...values,
            store_image_name: storeData?.store_image_name,
            file,
            store_id: storeData?.store_id,
          },
          config2
        );
        setResponse(submit);
        setOpen(true);
        // fetchStoreList();
        if (submit.status === "success") {
          navigate("/store");
        }
      } else {
        const submit = await insertStoreData({ ...values, timings, file }, config2);
        setResponse(submit);
        // fetchStoreList();
        setOpen(true);
        if (submit.status === "success") {
          navigate("/store");
        }
      }
    },
  });

  return (
    <>
      <Container>
        <Title variant="h5" className="w-[100%]">
          Enter Store Details.
        </Title>
        <ContainerForm>
          {open && (
            <AlertSnack
              open={open}
              setOpen={setOpen}
              response={response}
              setLoading={setLoading}
              route="customers"
            />
          )}

          {loading ? (
            <div className="items-center">
              <BeatLoader color="#36d7b7" />
            </div>
          ) : (
            <div style={{ width: "60%", margin: "auto" }}>
              <FormGroup>
                <InputLabel htmlFor="store_name">Store Name:<span className='text-[red]'>** </span> </InputLabel>
                <OutlinedInput
                  name="store_name"
                  placeholder="Enter Store Name"
                  id="store_name"
                  type="text"
                  value={formik.values.store_name}
                  onChange={formik.handleChange}
                />
              </FormGroup>
              <br />
              <FormGroup>
                <InputLabel htmlFor="store_description">
                  Store Description:{" "}<span className='text-[red]'>** </span>
                </InputLabel>
                <OutlinedInput
                  name="store_description"
                  placeholder="Enter Store Description"
                  id="store_description"
                  type="text"
                  value={formik.values.store_description}
                  onChange={formik.handleChange}
                />
              </FormGroup>
              <br />
              <FormGroup>
                <InputLabel htmlFor="store_address">Store Address:<span className='text-[red]'>** </span> </InputLabel>
                <OutlinedInput
                  name="store_address"
                  placeholder="Enter Store Description"
                  id="store_address"
                  type="text"
                  value={formik.values.store_address}
                  onChange={formik.handleChange}
                />
              </FormGroup>
              <br />
              <FormGroup>
                <InputLabel htmlFor="store_number">Store Number:<span className='text-[red]'>** </span> </InputLabel>
                <OutlinedInput
                  name="store_number"
                  placeholder="Enter Store Description"
                  id="store_number"
                  type="number"
                  value={formik.values.store_number}
                  onChange={formik.handleChange}
                />
              </FormGroup>
              <br />
              <div className="flex flex-wrap justify-between mb-5">
                <p className="w-[100%]">Store Timings:<span className='text-[red]'>** </span></p>
                <FormGroup className="w-1/2">
                  <InputLabel htmlFor="store_timings">
                    From:{" "}
                  </InputLabel>
                  <OutlinedInput
                    name="store_timings"
                    placeholder="Enter Store Timings"
                    id="store_timings"
                    type="time"
                    value={timings.from}
                    onChange={(e) => setTimings(prev => ({...prev, from: e.target.value}))}
                  />
                </FormGroup>
                <FormGroup className="w-1/2">
                  <InputLabel htmlFor="store_timings">
                    To:{" "}
                  </InputLabel>
                  <OutlinedInput
                    name="store_timings"
                    placeholder="Enter Store Timings"
                    id="store_timings"
                    type="time"
                    value={timings.to}
                    onChange={(e) => setTimings(prev => ({...prev, to: e.target.value}))}
                  />
                </FormGroup>
              </div>
              <FormGroup>
                <InputLabel id="demo-simple-select-label">City:<span className='text-[red]'>** </span></InputLabel>
                <Select
                  id="demo-simple-select"
                  name="city_id"
                  value={formik.values.city_id}
                  style={{ textAlign: "left" }}
                  onChange={formik.handleChange}
                >
                  {cityList?.map((city) => {
                    return (
                      <MenuItem value={city?.city_id} key={city?.city_id}>
                        {city?.city_name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormGroup>
              <br />
              <FormGroup>
                <InputLabel htmlFor="file">Store Image:<span className='text-[red]'>** </span> </InputLabel>
                <OutlinedInput
                  name="file"
                  placeholder="Select Image"
                  id="file"
                  type="file"
                  // value={file}
                  onChange={(e) => setFile(e.target.files[0])}
                />
              </FormGroup>
              <br />
              <div className="flex flex-row justify-between">
                <Button
                  type="button"
                  variant="contained"
                  color="info"
                  onClick={() => navigate("/store")}
                  style={{
                    marginTop: "1rem",
                    width: "48%",
                  }}
                >
                  Back
                </Button>
                <Button
                  type="button"
                  variant="contained"
                  color="info"
                  onClick={formik.handleSubmit}
                  style={{
                    marginTop: "1rem",
                    width: "48%",
                  }}
                >
                  Save & Continue
                </Button>
              </div>
              {/* <Button
          fullWidth
          type="button"
          variant='contained'
          color='info'
          onClick={logList}
          style={{
            margin: "1rem auto"
          }}
          >
          Click Me TO Check
        </Button> */}
            </div>
          )}
        </ContainerForm>
        <ContainerFormRight>
          <div className="flex flex-wrap">
            <p className="text-2xl mb-4 w-[100%]">
              <b>Image Preview</b>
            </p>
            <hr />
            {location?.pathname.includes("update") ? (
              <div className="w-[50%] mb-12">
                <p className="text-xl mb-4">
                  <b>Old Image</b>
                </p>
                <img
                  className=" m-auto"
                  src={storeData?.store_image_file}
                  alt={storeData?.store_image_name}
                />
              </div>
            ) : null}
            <div className="w-[50%]">
              <p className="text-xl mb-4">
                <b>New Image</b>
              </p>
              {file ? (
                <img
                  className=" m-auto"
                  src={URL.createObjectURL(file)}
                  alt={storeData?.store_image_name}
                />
              ) : (
                <p>No Image Selected</p>
              )}
            </div>
          </div>
        </ContainerFormRight>
      </Container>
    </>
  );
};
